import { PartnerWordmark } from '@/components/generals/partner-wordmark'
import { Reveal } from '@/components/generals/reveal'
import { SectionHeading } from '@/components/generals/section-heading'
import { PARTNERS } from '@/constants/partners'

export const AboutStrip = () => {
    return (
        <section id='about-us' aria-label='About us' className='relative py-24 sm:py-32'>
            <div className='shell'>
                <SectionHeading
                    eyebrow='Who we are'
                    title='Chosen by people who *plan ahead*'
                    subtitle='More than 1.2 million members, alongside the banks and institutions they already know, turn to Verdane for a clearer picture and steadier decisions.'
                />
            </div>

            <ul className='shell mt-16 flex flex-wrap items-center justify-center gap-x-12 gap-y-9 text-[17px] sm:text-lg lg:flex-nowrap lg:justify-between lg:gap-x-8'>
                {PARTNERS.map((partner, index) => (
                    <Reveal as='li' key={partner.id} delay={index * 160} y={10} blur={8}>
                        <PartnerWordmark id={partner.id} className='opacity-80 transition-opacity duration-500 hover:opacity-100' />
                    </Reveal>
                ))}
            </ul>
        </section>
    )
}
